import axios from "axios";

const api = axios.create({
    baseURL: "https://kw41fi5rla.execute-api.ap-south-1.amazonaws.com",
});

export const scheduleMeeting = (data) => {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await api.post("/meet", data);
            console.log(response.data);
            resolve(response.data);
        } catch (error) {
            reject(error);
        }
    });
};

export default api;
